import React from 'react'
import CommonLayout from '../../../../Components/CommonLayout/CommonLayout'
import Review from './Review'


function OrderReview({meta}) { 

  return (
    <div className='main-content'>
        <CommonLayout/>
        <Review/>
    </div>
  )
}

export default OrderReview